import React from 'react';
import _get from 'lodash/get';
import I18n from 'i18n-js';
import { pushNotificationAction } from 'actions/app-actions';
import ClickOnce from 'components/v2/click-once';
import { NOTIFICATION_TYPE } from 'components/v2/notification/notification';
import { getDuplicatedDeliveryIDs } from 'helper/anytime-booking';
import { getErrorMessage, getDeliveryErrors } from 'epics/v2/common-errors';

export default (
  dispatch,
  successfulDeliveryIDs,
  failedDeliveryIDs,
  error,
  deliveryErrors,
  retryDeliveries,
) => {
  const successfulCount = _get(successfulDeliveryIDs, 'length', 0);
  const failedCount = _get(failedDeliveryIDs, 'length', 0);
  const totalCount = successfulCount + failedCount;

  let id, type, message, description;
  if (!error && failedCount === 0) {
    id = 'successfulCreation';
    type = NOTIFICATION_TYPE.CONFIRMED;
    message =
      successfulCount > 1
        ? I18n.t(
            'v2.homepage.manualOrder.notification.createOrderSuccessful.title.other',
            { amt: successfulCount },
          )
        : I18n.t(
            'v2.homepage.manualOrder.notification.createOrderSuccessful.title.one',
          );
    description =
      I18n.t(
        'v2.homepage.manualOrder.notification.createOrderSuccessful.description',
      ) +
      I18n.t(
        'v2.homepage.manualOrder.notification.createOrderSuccessful.descriptionLink',
      );
  } else {
    id = 'failedCreation';
    type = NOTIFICATION_TYPE.WARNING;
    message =
      totalCount === 1
        ? I18n.t(
            'v2.homepage.manualOrder.notification.createOrderFailed.title.one',
          )
        : successfulCount === 0
          ? I18n.t(
              'v2.homepage.manualOrder.notification.createOrderFailed.title.zero',
              { total: totalCount },
            )
          : I18n.t(
              'v2.homepage.manualOrder.notification.createOrderFailed.title.other',
              { amt: failedCount, total: totalCount },
            );
    // eslint-disable-next-line react/display-name
    description = () => (
      <div>
        <p>
          {I18n.t(
            'v2.homepage.manualOrder.notification.createOrderFailed.description',
          )}
          {retryDeliveries ? (
            <ClickOnce
              onClick={() =>
                retryDeliveries(
                  failedDeliveryIDs,
                  getDuplicatedDeliveryIDs(deliveryErrors),
                )
              }
            >
              {I18n.t(
                'v2.homepage.manualOrder.notification.createOrderFailed.descriptionLink',
              )}
            </ClickOnce>
          ) : (
            I18n.t(
              'v2.homepage.manualOrder.notification.createOrderFailed.descriptionLink',
            )
          )}
        </p>
        {error && <p> {getErrorMessage(error)}</p>}
        {deliveryErrors &&
          getDeliveryErrors(deliveryErrors).map(
            ({ deliveryID, displayText }) => (
              <p key={deliveryID}>{displayText}</p>
            ),
          )}
      </div>
    );
  }

  dispatch(
    pushNotificationAction({
      id,
      type,
      message,
      description,
    }),
  );
};
